// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"85a2026f","239":"a2d85800","453":"ca7e61f3","455":"c28ea344"}[chunkId] + ".chunk.js";
};